/*
 * Backpack - Skyscanner's Design System
 *
 * Copyright 2016 Skyscanner Ltd
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { getDataComponentAttribute } from "../../bpk-react-utils";
import BpkBannerAlertInner from "./BpkBannerAlertInner";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated use bpk-component-info-banner instead
 * @returns {Component} a banner alert component
 */
const BpkBannerAlert = ({
  animateOnEnter = false,
  animateOnLeave = false,
  icon = null,
  show = true,
  ...rest
}) => /*#__PURE__*/_jsx(BpkBannerAlertInner, {
  animateOnEnter: animateOnEnter,
  animateOnLeave: animateOnLeave,
  show: show,
  icon: icon,
  ...getDataComponentAttribute('BannerAlert'),
  ...rest
});
export default BpkBannerAlert;